import styled from 'styled-components'
import EnterpriseIcon from '@enterprise-ui/icons'

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;

  &::after {
    content: '';
    height: 42px;
    width: 0.5px;
    background-color: #fff;
    margin: 0 5px;
  }
`

export const DropdownButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 15px;
  white-space: nowrap;
  border-radius: 4px;
  transition: background-color 0.2s;
  width: 192px;
  max-width: 192px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.4);
  }
`

export const AccountLabel = styled.span`
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DropdownMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% - 8px);
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 9px;
  min-width: 260px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  z-index: 1000;
  max-height: 320px;
  overflow-y: auto;
  padding: 4px 0;
`

export const SearchContainer = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 0 8px 4px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  background: #fff;
  color: #666;

  &:focus-within {
    border-color: #666;
  }
`

export const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  color: #333;
  background: transparent;

  &::placeholder {
    color: #999;
  }
`

export const NoResults = styled.div`
  padding: 12px 16px;
  font-size: 14px;
  color: #999;
`

export const DropdownItem = styled.button<{ isSelected: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: ${(props) => (props.isSelected ? '#f5f5f5' : 'white')};
  color: #333;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${(props) => (props.isSelected ? 600 : 400)};
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`

export const ChevronIcon = styled(EnterpriseIcon)<{ $isOpen: boolean }>`
  transition: transform 0.2s;
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`
